/* unplugin-vue-components disabled */import { render } from "./backlog.vue?vue&type=template&id=2c4875e1&scoped=true"
import script from "./backlog.vue?vue&type=script&lang=js"
export * from "./backlog.vue?vue&type=script&lang=js"

import "./backlog.vue?vue&type=style&index=0&id=2c4875e1&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c4875e1"]])

export default __exports__